import React, { useMemo, forwardRef, useState } from 'react';
import styles from './FJButton.module.less';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import FJAutoLoading from '../FJLoading/FJAutoLoading.jsx';
import FJHoverBoardGradation from '../FJHoverBoard/FJHoverBoardGradation.jsx';

const FJBorderButton = forwardRef((props, ref) => {
    const {
        className,
        text,

        isLoading,
        type = 'default',
        disabled,

        textClassName,
        style,

        icon,
        rightIcon,
        onClick = () => {},
    } = props;

    const cn = useMemo(() => {
        switch (type) {
            default:
                return styles.white;
        }
    }, [type]);

    const _onClick = e => {
        if (isLoading || disabled) {
            return;
        }
        onClick(e);
    };

    const [isMouseIn, setIsMouseIn] = useState(false);
    const _onMouseEnter = () => {
        setIsMouseIn(true);
    };

    const _onMouseLeave = () => {
        setIsMouseIn(false);
    };

    return (
        <FJHoverBoardGradation active={isMouseIn} borderRadius={8} hasHover={false} isShowInBorder={true}>
            <div
                ref={ref}
                className={classNames(cn, { [styles.disabled]: disabled }, className)}
                style={style}
                onClick={_onClick}
                onMouseEnter={_onMouseEnter}
                onMouseLeave={_onMouseLeave}
            >
                <div className={classNames(styles.btn, { [styles.opacity_0]: isLoading })}>
                    {icon}
                    {text && <span className={classNames(textClassName)}>{FJLocalStore._(text)}</span>}
                    {rightIcon}
                </div>
            </div>
        </FJHoverBoardGradation>
    );
});
export default FJBorderButton;
